import { Routes } from '@angular/router';
import { productGuard } from 'app/core/guards/product.guard';
import { rateControllerSelectionGuard } from '../rate-controller/services/rate-controller-routing';

export const rateControllerRoutes: Routes = [
    {
        path: 'dashboard/rate-controller-single',
        title: 'Rate Controller',
        canActivate: [productGuard('rate'), rateControllerSelectionGuard],
        loadComponent: () =>
            import('app/products/rate-controller/dashboards/rc-single/rc-single.component').then(
                m => m.OrmaDashboardComponent
            ),
    },
    {
        path: 'dashboard/rate-controller-corp',
        title: 'Rate Controller - Corporate View',
        canActivate: [productGuard('rate'), rateControllerSelectionGuard],
        loadComponent: () =>
            import('app/products/rate-controller/dashboards/rc-corp/rc-corp.component').then(
                m => m.RCCorpComponent
            ),
    },
];
